export default "<div class=\"transporteur\">\n  {{TransporteurInComponent}}\n</div>\n\n";